if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        init() {
          // Toestemming wordt nooit onthouden. Het vakje start altijd leeg.
          this.checked = false;
          if (localStorage.cart_term_checked) {
            localStorage.removeItem('cart_term_checked');
          }

          this.$watch('checked', () => {
            this.save();
          });

          document.addEventListener('eurus:cart:validate', () => {
            if (!this.checked) Alpine.store('xCartHelper').validated = false;
          });
        },
        save() {
          clearTimeout(this.t);

          const func = () => {
            var status = this.checked ? 'agreed' : 'not agreed';
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': status
              }
            });
          }

          this.t = setTimeout(() => {
            func();
          }, 200);
        }
      }));
    })
  });
};